import { MenuItemType } from '@/app/types/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { adminRole, csRole, superAdminRole } from '@/app/constants';

type UserDropdownItemType = {
  label?: string;
  icon?: string;
  url?: string;
  isDivider?: boolean;
  isHeader?: boolean;
  class?: string;
};

// Định nghĩa menu items cố định
const MENU_ITEMS: MenuItemType[] = [
  // { label: 'MENU.TITLE', isTitle: true },
  // {
  //   label: 'MENU.REPORT_OVERVIEW',
  //   icon: 'tablerChartHistogram',
  //   url: '/dashboard',
  //   allowRoles: [superAdminRole, adminRole],
  // },
  // {
  //   label: 'MENU.REPORT_DETAIL',
  //   icon: 'tablerChartDonut',
  //   isCollapsed: true,
  //   children: [
  //     { label: 'MENU.REPORT_ACCESS', url: '/reports/access' },
  //     { label: 'MENU.REPORT_GENDER', url: '/reports/gender' },
  //     { label: 'MENU.REPORT_AGE', url: '/reports/age' },
  //   ],
  //   allowRoles: [superAdminRole, adminRole],
  // },
  {
    label: 'MENU.MANAGE_USERS',
    icon: 'tablerChartDonut',
    isCollapsed: true,
    children: [
      { label: 'USERS.MENU.LIST', url: '/users/list', allowRoles: [superAdminRole, adminRole] },
      { label: 'USERS.MENU.CREATE', url: '/users/create', allowRoles: [superAdminRole] },
    ],
    allowRoles: [superAdminRole, adminRole],
  },
  {
    label: 'MENU.CAMPAIGN_MANAGE',
    icon: 'tablerChartDonut',
    isCollapsed: true,
    children: [
      { label: 'MENU.CAMPAIGN_LIST', url: '/campaigns/list' },
      // { label: 'MENU.CAMPAIGN_CREATE_DOOH', url: '/campaigns/create', queryParams: { type: 'dooh' }, allowRoles: [superAdminRole, adminRole] },
      // { label: 'MENU.CAMPAIGN_CREATE_NFC', url: '/campaigns/create', queryParams: { type: 'nfc' }, allowRoles: [superAdminRole, adminRole] },
      { label: 'CAMPAIGN.TRANSFER_POINT.IMPORT.TITLE', url: '/campaigns/device-transfers', allowRoles: [superAdminRole, adminRole] },
      { label: 'MENU.DEVICE_MAKEGOOD.LIST', url: '/campaigns/device-makegood', allowRoles: [superAdminRole] },
    ],
  },
  {
    label: 'MENU.AUDIT_LOG',
    icon: 'tablerHistory',
    isCollapsed: true,
    allowRoles: [superAdminRole],
    children: [
      { label: 'MENU.AUDIT_LOG.HISTORY', url: '/audit-logs/list', allowRoles: [superAdminRole] },
    ],
  },
];

// Export dữ liệu menu ban đầu (cho khả năng tương thích ngược)
export const menuItems: MenuItemType[] = [...MENU_ITEMS];
export const horizontalMenuItems: MenuItemType[] = [...MENU_ITEMS];

/**
 * Service quản lý menu với hỗ trợ đa ngôn ngữ
 */
@Injectable({
  providedIn: 'root'
})
export class MenuService {
  // Subjects để theo dõi thay đổi menu
  private _menuItems = new BehaviorSubject<MenuItemType[]>([...MENU_ITEMS]);
  private _horizontalMenuItems = new BehaviorSubject<MenuItemType[]>([...MENU_ITEMS]);

  // Observables public để components có thể đăng ký
  public menuItems$ = this._menuItems.asObservable();
  public horizontalMenuItems$ = this._horizontalMenuItems.asObservable();

  constructor(private translateService: TranslateService) {
    // Đăng ký sự kiện khi ngôn ngữ thay đổi
    this.translateService.onLangChange.subscribe(() => {
      // Phát lại menu items để các components cập nhật
      this._menuItems.next([...MENU_ITEMS]);
      this._horizontalMenuItems.next([...MENU_ITEMS]);
    });
  }

  /**
   * Lấy danh sách menu items hiện tại
   */
  get menuItems(): MenuItemType[] {
    return [...MENU_ITEMS];
  }

  /**
   * Lấy danh sách horizontal menu items hiện tại
   */
  get horizontalMenuItems(): MenuItemType[] {
    return [...MENU_ITEMS];
  }
}
